import {Component, Input, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {uuid} from "../../utils";

@Component({
    selector: 'app-tab-item',
    templateUrl: './tab-item.component.html',
    styleUrls: ['./tab-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabItemComponent {
  @ViewChild("tabHeader") tabHeader: TemplateRef<any>;
  @Input() templateRef!: TemplateRef<any>;
  @Input() alwaysRender: boolean = true;

  uniqueTabItemId: string = uuid();
}
